<template>
  <header></header>
  <div class="jobs">
    <Person />
  </div>
</template>

<script>
import Person from "./components/person.vue";
export default {
  name: "App",
  components: {
    Person,
  },
};
</script>

<style lang="scss">
body {
  margin: 0px;
  font-size: 15px;
}
header {
  background-image: url("./assets/images/bg-header-desktop.svg");
  background-color: hsl(180, 29%, 50%);
  height: 156px;
}
.jobs {
  background-color: hsl(180, 52%, 96%);
  padding-top: 20px;
}
</style>
